export default __webpack_public_path__ + "static/media/cosmosHolo.53b6eaf3.svg";